import { render, staticRenderFns } from "./projectSelct.vue?vue&type=template&id=3f58be5c&scoped=true&"
import script from "./projectSelct.vue?vue&type=script&lang=js&"
export * from "./projectSelct.vue?vue&type=script&lang=js&"
import style0 from "./projectSelct.vue?vue&type=style&index=0&id=3f58be5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58be5c",
  null
  
)

component.options.__file = "projectSelct.vue"
export default component.exports